import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Toast } from 'vant'
import { isSuperAdmin } from '@/utils/permission'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => {
    if (err && err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录', public: true }
  },
  {
    path: '/login-success',
    name: 'LoginSuccess',
    component: () => import('@/views/LoginSuccess.vue'),
    meta: { title: '登录成功', public: true }
  },
  {
    path: '/wecom-entry',
    name: 'WeComEntry',
    component: () => import('@/views/WeComEntry.vue'),
    meta: { title: '企业微信登录', public: true }
  },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/Dashboard.vue'),
        meta: { title: '首页', icon: 'el-icon-house' }
      },
      {
        path: 'drones/:droneId',
        name: 'DroneDetail',
        component: () => import('@/views/drone/DroneDetail.vue'),
        meta: { title: '无人机详情' }
      },
      {
        path: 'hangars',
        name: 'HangarList',
        component: () => import('@/views/hangar/HangarList.vue'),
        meta: { title: '机库管理', icon: 'el-icon-office-building' }
      },
      {
        path: 'hangars/:id',
        name: 'HangarDetail',
        component: () => import('@/views/hangar/HangarDetail.vue'),
        meta: { title: '机库详情' }
      },
      {
        path: 'hangars/:id/logs',
        name: 'HangarFlightLog',
        component: () => import('@/views/hangar/HangarFlightLog.vue'),
        meta: { title: '机库飞行日志' }
      },
      {
        path: 'maintenance-status',
        name: 'EquipmentStatus',
        component: () => import('@/views/maintenance/EquipmentStatus.vue'),
        meta: { title: '检查保养', icon: 'el-icon-document-checked' }
      },
      {
        path: 'checks',
        name: 'CheckList',
        component: () => import('@/views/check/CheckList.vue'),
        meta: { title: '检查记录', icon: 'el-icon-document-checked' }
      },
      {
        path: 'checks/create',
        name: 'CheckCreate',
        component: () => import('@/views/check/CheckForm.vue'),
        meta: { title: '新建检查记录' }
      },
      {
        path: 'checks/detail',
        name: 'CheckTemplateDetail',
        component: () => import('@/views/check/CheckDetail.vue'),
        meta: { title: '检查详情' }
      },
      {
        path: 'checks/:id',
        name: 'CheckDetail',
        component: () => import('@/views/check/CheckDetail.vue'),
        meta: { title: '检查记录详情' }
      },
      {
        path: 'checks/:id/edit',
        name: 'CheckEdit',
        component: () => import('@/views/check/CheckForm.vue'),
        meta: { title: '编辑检查记录' }
      },
      {
        path: 'maintenances',
        name: 'MaintenanceList',
        component: () => import('@/views/maintenance/MaintenanceList.vue'),
        meta: { title: '保养管理', icon: 'el-icon-setting' }
      },
      {
        path: 'maintenances/create',
        name: 'MaintenanceCreate',
        component: () => import('@/views/maintenance/MaintenanceForm.vue'),
        meta: { title: '新建保养记录' }
      },
        {
          path: 'maintenances/detail',
          name: 'MaintenanceDetailByCache',
          component: () => import('@/views/maintenance/MaintenanceDetail.vue'),
          meta: { title: '保养记录详情' }
        },
        {
          path: 'maintenances/:id',
          name: 'MaintenanceDetail',
          component: () => import('@/views/maintenance/MaintenanceDetail.vue'),
        meta: { title: '保养记录详情' }
      },
      {
        path: 'maintenances/:id/edit',
        name: 'MaintenanceEdit',
        component: () => import('@/views/maintenance/MaintenanceForm.vue'),
        meta: { title: '编辑保养记录' }
      },
      {
        path: 'tickets',
        name: 'TicketList',
        component: () => import('@/views/ticket/TicketList.vue'),
        meta: { title: '工单管理' }
      },
      {
        path: 'tickets/create',
        name: 'TicketCreate',
        component: () => import('@/views/ticket/TicketForm.vue'),
        meta: { title: '创建工单' }
      },
      {
        path: 'tickets/:id',
        name: 'TicketDetail',
        component: () => import('@/views/ticket/TicketDetail.vue'),
        meta: { title: '工单详情' }
      },
      {
        path: 'tickets/:id/edit',
        name: 'TicketEdit',
        component: () => import('@/views/ticket/TicketForm.vue'),
        meta: { title: '编辑工单' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/profile/Profile.vue'),
        meta: { title: '我的' }
      },
      {
        path: 'spare-parts',
        name: 'SparePartList',
        component: () => import('@/views/spare/SparePartList.vue'),
        meta: { title: '备品备件', requiresSuperAdmin: true }
      },
      {
        path: 'approvals',
        name: 'ApprovalCenter',
        component: () => import('@/views/approval/ApprovalCenter.vue'),
        meta: { title: '审批中心', requiresSuperAdmin: true }
      },
      {
        path: 'messages',
        name: 'MessageCenter',
        component: () => import('@/views/message/MessageCenter.vue'),
        meta: { title: '消息中心', requiresSuperAdmin: true }
      },
      {
        path: 'help',
        name: 'HelpCenter',
        component: () => import('@/views/help/HelpCenter.vue'),
        meta: { title: '帮助中心', requiresSuperAdmin: true }
      },
      {
        path: 'about',
        name: 'AboutUs',
        component: () => import('@/views/about/AboutUs.vue'),
        meta: { title: '关于我们', requiresSuperAdmin: true }
      },
      {
        path: 'users',
        name: 'UserList',
        component: () => import('@/views/user/UserList.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/settings/Settings.vue'),
        meta: { title: '系统设置' }
      },
      {
        path: 'crashes',
        name: 'CrashList',
        component: () => import('@/views/crash/CrashList.vue'),
        meta: { title: '炸机上报' }
      },
      {
        path: 'crashes/:id',
        name: 'CrashDetail',
        component: () => import('@/views/crash/CrashDetail.vue'),
        meta: { title: '炸机详情' }
      }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  document.title = to.meta.title ? `${to.meta.title} - 无人机运维管理系统` : '无人机运维管理系统'

  if (to.meta.public) {
    next()
    return
  }

  if (!store.getters.isLoggedIn) {
    next({
      path: '/wecom-entry',
      query: { redirect: to.fullPath }
    })
    return
  }

  if (!store.getters.userInfo) {
    try {
      await store.dispatch('fetchUserInfo')
    } catch (error) {
      store.dispatch('logout')
      next('/login')
      return
    }
  }

  if (to.meta.requiresSuperAdmin && !isSuperAdmin()) {
    Toast.fail('仅超级管理员可访问')
    next('/profile')
    return
  }

  next()
})

router.afterEach(() => {
  NProgress.done()
})

export default router
